import React from 'react';

import { Checkbox, FormControlLabel, Paper } from '@material-ui/core';

import { IAdminMembership } from '../../../../store/admin/memberships/store';

import { PlayerRenderer } from './PlayerRenderer';

interface IProps {
  item: IAdminMembership;
  context?: any;
}

export const Player = (props: IProps) => {
  const { item, context } = props;

  const isDisabled = !item.user.firstName || context.invited.includes(item.user.id);

  return (
    <Paper className="paper-player" elevation={0} square={true}>
      <FormControlLabel
        color="primary"
        control={
          <div className="checkbox-wrapper">
            <Checkbox
              checked={
                !!context.selectedMembers.find((member: any) => item.id === member.id) ||
                !item.user.firstName
              }
              color="primary"
              disabled={isDisabled}
              indeterminate={isDisabled}
              indeterminateIcon={<div className="mini-tag">invited</div>}
            />
          </div>
        }
        label={<PlayerRenderer {...props} />}
        onChange={context.memberSelection.bind(null, item)}
      />
    </Paper>
  );
};
